import React from 'react';
import CusEntInfoContainer from './corp-info-container';

const CusEntInfoPage = () => {
  return <CusEntInfoContainer />;
};

export default CusEntInfoPage;
